import { Body, breakpoints, Dialog, Spacer } from '@spritz-finance/ui'
import React, { useContext, useState } from 'react'
import styled from 'styled-components'
import TestPaymentSVG from '../../assets/img/test-payment.svg'
import { Row } from '../../components/Layout/Row'
import { themedImage } from '../../theme/utils'
import { Column } from '../../components/Layout/Column'
import { ContentContainer } from '../../components/ContentContainer'

export const TestPaymentImage = styled.img.attrs({
    src: themedImage('billTypeLoan', TestPaymentSVG),
})`
    height: 80px;
`

type IContext = {
    openDialog: () => void
}

const TestPaymentDialogState = React.createContext<IContext>({ openDialog: () => {} })

export const TestPaymentLearnMoreWrapper = styled.span`
    text-decoration: underline;
    cursor: pointer;
`

export const useTestPaymentInfoDialog = () => {
    const context = useContext(TestPaymentDialogState)
    // if (!context)
    //     throw new Error(
    //         'Cannot use useTestPaymentInfoDialog outside of a <TestPaymentDialogProvider />'
    //     )
    return context
}

const LiWrapper = styled.li`
    margin-bottom: 24px;
`

const StyledContentWrapper = styled(ContentContainer)`
    max-height: 500px;
    overflow: scroll;
    ${breakpoints.xsmall} {
        max-height: unset;
        overflow: unset;
    }
`

export const TestPaymentInfoDialogProvider: React.FC = ({ children }) => {
    const [open, setOpen] = useState<boolean>(false)

    const openDialog = () => {
        setOpen(true)
    }

    const handleClose = () => {
        setOpen(false)
    }

    return (
        <TestPaymentDialogState.Provider value={{ openDialog }}>
            {children}
            <Dialog open={open} onClose={handleClose}>
                <Dialog.Content contentPadding={false} minWidth={560} style={{ minHeight: 200 }}>
                    <Dialog.Title>Get a taste of Spritz</Dialog.Title>
                    <StyledContentWrapper>
                        <Spacer height={16} />

                        <Row align="center">
                            <Column align="center">
                                <Spacer height={16} />
                                <Body.SmBold align="center">
                                    Make your first payment when you connect a new bill and we'll
                                    match up to $10
                                </Body.SmBold>
                            </Column>
                        </Row>

                        <Spacer height={32} />
                        <Row>
                            <Body.Reg size={16}>
                                Welcome to Spritz! We're refreshing your finances with direct crypto
                                bill pay. To welcome you, we'll match your first payment amount up
                                to $10 per bill for each new bill you add in the first 7 days after
                                you verify your Spritz account.
                            </Body.Reg>
                        </Row>

                        <Spacer height={16} />
                        <Row>
                            <Body.Reg size={16}>
                                That's $10 toward your credit card, $10 toward your electric bill,
                                $10 toward your student loan, and for any other bill you add in that
                                first week!
                            </Body.Reg>
                        </Row>

                        <Spacer height={16} />
                        <Row>
                            <Body.Reg size={16}>Here's the fine print:</Body.Reg>
                        </Row>

                        <Spacer height={8} />
                        <ul>
                            <LiWrapper>
                                Once you connect a bill, you'll have 7 days to make a payment in
                                order to get the match of up to $10. If your bill requires
                                verification before you can pay it, that 7 days won't start until
                                the bill is payable in our system.
                            </LiWrapper>
                            <LiWrapper>
                                You'll need to fund a minimum payment of $1 using any token from
                                your wallet. However much you put toward the bill up to $10, we'll
                                match it! That means if you make a $1 payment, we'll add $1, $5 for
                                $5, and so on.
                            </LiWrapper>
                            <LiWrapper>
                                You'll have to pay the gas fees, so make sure you have enough of the
                                native token for the network you are using in your wallet.
                            </LiWrapper>
                            <LiWrapper>
                                Remember this is just an initial payment, so it doesn't have to
                                fulfill your minimum balance for the bill. If your bill is due,
                                however, you'll need to pay the minimum amount in order for the
                                billing provider to accept it.
                            </LiWrapper>
                            <LiWrapper>
                                If you signed up through a referral link, the full amount of your
                                first payment (including our matched credit) will be applied toward
                                the minimum $50 needed to qualify for the reward credit.
                            </LiWrapper>
                        </ul>
                        <Spacer height={32} />
                    </StyledContentWrapper>
                </Dialog.Content>
            </Dialog>
        </TestPaymentDialogState.Provider>
    )
}
